import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import SearchSelectList from '../SearchSelectList';
import SearchSelectListItem from '../SearchSelectListItem';
import {
  getOpportunities,
  addOpportunityFavorite,
  removeOpportunityFavorite
} from '../../../actions/userActions';
import { modalController } from "../../../actions/domActions";
import { formatOpportunityCloseDate } from '../../../utils/date';
import stringUtils from "../../../utils/string";

// SASS Imports
require('./OpportunitySearchSelectList.scss');

function mapStateToProps(store) {
  return {
    api: store.api,
    favorites: enforceArray(store.favorites.opportunities),
  }
};

function mapDispatchToProps (dispatch, ownProps) {
  return {
    showOpportunities: account => dispatch(modalController("SHOW_OPPORTUNITIES_FOR", {account})),
    getOpportunities: (filterQuery, size, from, accountId) => dispatch(getOpportunities({filterQuery, size, from, parentId: accountId})),
    addFavorite: opportunity => dispatch(addOpportunityFavorite(opportunity)),
    removeFavorite: opportunity => dispatch(removeOpportunityFavorite(opportunity))
  };
}


class OpportunitySearchSelectList extends Component {
  constructor(props) {
    super(props);
    // see the note for staticList in AccountSearchSelectList
    this.state = {
      staticList: this.assembleFavorites(props)
    };
    this.renderItem = this.renderItem.bind(this);
    this.onFetch = this.onFetch.bind(this);
  }

  assembleFavorites(props) {
    const { entry, favorites } = props;

    let favList = favorites !== undefined ? favorites.slice() : []

    if (favList.length > 0  && entry !== undefined) {
      if (entry.accountId) {
        const entryAccountId = entry.accountId.toString();

        favList = favList.filter(f => f && f.accountId ? f.accountId.toString() === entryAccountId : false);
      }
    }

    return favList;
  }

  onFetch(filterQuery, extraFilter, size, from) {
    const { entry } = this.props;
    const accountId = entry !== undefined && entry.hasOwnProperty('accountId') && entry.accountId.length !== 0
      ? entry.accountId
      : '';
    return this.props.getOpportunities(filterQuery, size, from, accountId);
  }

  renderItem(opportunity, props) {
    return (
      <SearchSelectListItem
        item={opportunity}
        key={opportunity.opportunityId}
        rowClassName="opportunityListItem"
        selectText="Select Opportunity"
        onSelectItem={ this.props.onSelectItem }
        mainColSize={8}
        hasAddToFavorites={this.props.hasAddToFavorites}
        {...props}
      >
        <h5 className="opportunityName">{ opportunity.opportunityId }: { opportunity.opportunityName }</h5>
        <div className="location">
          Amount: {stringUtils.formatAmount(opportunity.opportunityUsdAmount)} USD
        </div>
        <div className="location">
          Account Manager: {opportunity.primaryAccountManager}
        </div>
        <div className="location">
          Stage: {opportunity.opportunityStage}
        </div>
        <div className="location">
          Deal Type: {opportunity.dealType}
        </div>
        <div className="location">
          Close Date: {formatOpportunityCloseDate(opportunity.closeDate)}
        </div>
      </SearchSelectListItem>
    );
  }
  render() {
    const { entry } = this.props;
    const showAllLink = entry && entry.hasOwnProperty('account') ? "Show all opportunities" : null;

    return (
      <SearchSelectList
        title="Select Opportunity"
        searchPlaceholder="Search Opportunities"
        onFetch={this.onFetch}
        showAllLink={showAllLink}
        staticListResults={this.state.staticList}
        showFilter={false}
        itemProps={{
          hasAddToFavorites: true,
          onFavoriteItem: opportunity => this.props.addFavorite(opportunity),
          onRemoveFavoriteItem: opportunity => this.props.removeFavorite(opportunity)
        }}
        renderItem={this.props.renderItem ? this.props.renderItem : this.renderItem}
        {...this.props}
      />
    );
  }
}

OpportunitySearchSelectList.propTypes = {
  addFavorite: PropTypes.func.isRequired,
  entry: PropTypes.object,
  favorites: PropTypes.array,
  getOpportunities: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  removeFavorite: PropTypes.func.isRequired,
  renderItem: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(OpportunitySearchSelectList);

function enforceArray(favorites) {
  if (Array.isArray(favorites)) {
    return favorites.filter(Boolean);
  } else {
    return [];
  }
}



// WEBPACK FOOTER //
// ./app/components/SelectLists/Types/OpportunitySearchSelectList.jsx